export default "__VITE_ASSET__9e56f5be__"